import FlatPage from './FlatPage';
export default FlatPage;
